// extracted by mini-css-extract-plugin
module.exports = {"container":"NewFavoritesTabInformer_container__VWAwz","text":"NewFavoritesTabInformer_text__4A04I","closeButton":"NewFavoritesTabInformer_closeButton__A7BSJ"};